import http from '@/http'

const callsApiService = {
  /**
   * Get Twilio access token for browser calling
   */
  async getAccessToken() {
    return http.get('/contacts/calls/token')
  },

  /**
   * Initiate a phone call (server-to-phone)
   */
  async initiateCall(data) {
    return http.post('/contacts/calls/initiate', data)
  },

  /**
   * Create call log for browser-initiated call
   */
  async createBrowserCallLog(data) {
    return http.post('/contacts/calls/browser/create-log', data)
  },

  /**
   * Save notes for a call
   */
  async saveNotes(callLogId, notes) {
    return http.post(`/contacts/calls/${callLogId}/notes`, { notes })
  },

  /**
   * Get call logs
   */
  async getCallLogs(page = 1) {
    return http.get('/contacts/calls', { params: { page } })
  },

  /**
   * Search for user by phone number
   */
  async searchUserByPhone(phone) {
    return http.get('/contacts/users/search-by-phone', { params: { phone } })
  },
}

export default callsApiService
